<template>
  <div class="columns">
    <div class="column">
      <button class="button" @click="seed">Seeda data</button>
      <button class="button" @click="seedProjects">Seeda ärenden</button>
      <button class="button" @click="seedWorkOrders">Seeda tjänster</button>
      <button class="button" @click="testSignalR">Testa SignalR</button>

      <div v-for="message in testMessageList" :key="message">
        <div>{{ message }}</div>
      </div>

      <button v-if="testMessageList.length > 0" class="button" @click="clearTestMessages">Rensa</button>
    </div>
    <div class="column">
    </div>
  </div>
</template>

<script>

import $axios from '@/axios-instance.js'

export default {
  data () {
    return {
      testMessageList: []
    }
  },

  methods: {
    testSignalR () {
      $axios.get(`${process.env.ROOT_API}/dev/test-signalr`).then(response => {
        this.$toast(response.data.message, 'success')
      })
    },

    seed () {
      $axios.get(`${process.env.ROOT_API}/dev/seed`).then(response => {
        this.$toast(response.data.message, 'success')
      })
    },

    seedProjects () {
      $axios.get(`${process.env.ROOT_API}/dev/seed-projects/10`).then(response => {
        this.$toast(response.data.message, 'success')
      })
    },

    seedWorkOrders () {
      $axios.get(`${process.env.ROOT_API}/dev/seed-work-orders/80`).then(response => {
        this.$toast(response.data.message, 'success')
      }).catch(error => {
        console.error(error)
        this.$toast('Icke!')
      })
    },

    onTestMessage (message) {
      this.testMessageList.push(message)
    },

    clearTestMessages () {
      this.testMessageList = []
    }
  },

  created () {
    this.$messageHub.$on('test-message', this.onTestMessage)
  },

  beforeDestroy () {
    this.$messageHub.$off('test-message', this.onTestMessage)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Settings/DevPageViews/Overview.vue